


























import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-billing-basic-configuration-comp": () =>
      import(
        "@/components/app/global/client/clientBillingBasicConfigurationComp.vue"
      ),
    "client-invoice-consolidation-comp": () =>
      import(
        "@/components/app/global/client/clientInvoiceConsolidationComp.vue"
      )
  }
})
export default class ClientBillingSettingsView extends Vue {
  // Props

  @Prop({ required: true })
  public client!: IClient;
}
